import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { ViewProps } from 'react-native'
import { Colors } from '../../util/util'

const defaultStyles = {
  sideMenucontainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 44,
    width: 220,
  } as BoxProps,
  sideMenuitemStyle: {
    color: 'WHITE',
    fontSize: 14,
    alignContent: 'center',
    marginHorizontal: 12,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  sideMenuleftHighLight: {
    width: 4,
    height: '100%',
    marginRight: 16,
  } as BoxProps,
  sideMenuIconImage: {
    height: 16,
    width: 16,
  } as BoxProps,
  iconColor: 'DARK_GREY',
  item: {} as TextProps,
  title: {} as TextProps,
  titleView: {} as BoxProps,
  textsize: {} as TextProps,
  titleHeader: {} as TextProps,
  titleheaderView: {} as BoxProps,
  header: {} as BoxProps,
  Success: {} as BoxProps,
  Failure: {} as BoxProps,
  linkStyle: {} as TextProps,
  selectedStyle: {} as BoxProps,
  gridStyle: {} as BoxProps,
  dateStyle: {} as TextProps,
  styledText: {} as TextProps,
  separator: (isTextData: boolean) =>
    ({
      borderTopWidth: 0.5,
      opacity: 0.4,
      pt: 16.5,
      pb: isTextData ? 16.5 : 0,
      mt: isTextData ? 16 : 10,
      borderColor: 'GREY_BORDER_ALPHA' as ColorOptions,
    } as BoxProps),
  sideMenuSubText: {
    color: 'WHITE',
    fontFamily: 'jiotype-medium',
    letterSpacing: 1.2,
    fontSize: 12,
    lineHeight: 20,
  } as TextProps,
  textContainer: {
    pl: 20,
  } as BoxProps,
}
const styles = {
  DEFAULT: {
    ...defaultStyles,
    ORIGINAL: {
      container: {
        flex: 1,
        height: 27,
        backgroundColor: 'WHITE',
      } as BoxProps,
      titleStyle: {} as TextProps,
      itemContainer: {} as BoxProps,
      itemStyle: {
        flex: 1,
        fontSize: 14,
        marginTop: 5,
        marginLeft: 10,
        paddingHorizontal: 8,
        textAlign: 'left',
        color: 'DARK_GREY',
        backgroundColor: 'WHITE',
      } as TextProps,
      separatorStyle: {
        height: 1,
        marginTop: 5,
        backgroundColor: 'GREY_SEPARATOR',
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemContainer: {} as BoxProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  EXPORT: {
    ...defaultStyles,
    ORIGINAL: {
      container: {
        flex: 1,
        height: 27,
        backgroundColor: 'WHITE',
        flexDirection: 'row',
        alignContent: 'space-between',
      } as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        flex: 1,
        fontSize: 12,
        paddingRight: 4,
        textAlign: 'left',
        color: 'DARK_GREY',
        backgroundColor: 'WHITE',
        alignSelf: 'center',
        fontWeight: '600',
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'GREY_1_SEPARATOR', // GREY_SHADE
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  SEARCH: {
    ...defaultStyles,
    iconColor: 'LIGHT_GRAY',
    styledText: {
      fontSize: 12,
      paddingVertical: 10,
      paddingLeft: 2,
      color: 'LIGHT_BLACK',
      backgroundColor: 'WHITE',
      fontWeight: '600',
      justifyContent: 'center',
    } as TextProps,
    ORIGINAL: {
      container: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: 'WHITE',
        flexDirection: 'row',
        paddingHorizontal: 8,
      } as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        fontSize: 14,
        paddingVertical: 10,
        paddingHorizontal: 8,
        color: 'DARK_GREY',
        fontWeight: '500',
        justifyContent: 'center',
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'SEPERATOR',
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {
        alignSelf: 'center',
        paddingLeft: 8,
      } as ViewProps,
      filterContainer: {
        backgroundColor: 'GREY_SEPARATOR',
        padding: 2,
        paddingHorizontal: 6,
        borderRadius: 2,
      } as BoxProps,
      filterOuterContainer: {
        width: 80,
        marginLeft: 10,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      } as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  SEARCH_FILTERS: {
    ...defaultStyles,
    iconColor: 'LIGHT_GRAY',
    styledText: {
      fontSize: 12,
      paddingVertical: 10,
      paddingLeft: 2,
      color: 'PRIMARY_GREY',
      backgroundColor: 'WHITE',
      fontWeight: '600',
      justifyContent: 'center',
    } as TextProps,
    ORIGINAL: {
      container: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: 'WHITE',
        flexDirection: 'row',
        paddingHorizontal: 18,
      } as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        fontSize: 12,
        paddingVertical: 10,
        paddingHorizontal: 8,
        color: 'PRIMARY_GREY',
        fontWeight: '500',
        justifyContent: 'center',
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'SEPERATOR',
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {
        alignSelf: 'center',
        paddingLeft: 8,
      } as ViewProps,
      filterContainer: {
        backgroundColor: 'BLUE', // BG_BLUE
        padding: 2,
        paddingHorizontal: 6,
        borderRadius: 2,
      } as BoxProps,
      filterOuterContainer: {
        width: 100,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      } as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  SIDE_MENU: {
    ...defaultStyles,
    iconColor: 'WHITE',
    ORIGINAL: {
      container: {
        ...defaultStyles.sideMenucontainer,
        opacity: 0.8,
      } as BoxProps,
      itemContainer: { paddingLeft: 23 } as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        ...defaultStyles.sideMenuitemStyle,
        opacity: 0.8,
      } as TextProps,
      separatorStyle: {} as BoxProps,
      leftHighlight: {
        ...defaultStyles.sideMenuleftHighLight,
        backgroundColor: 'TRANSPARENT',
      } as BoxProps,
      iconImage: {
        marginRight: 10,
      } as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {
        ...defaultStyles.sideMenucontainer,
        backgroundColor: 'WHITE_SEPERATOR', // 'rgba(255,255,255,0.05)',
        opacity: 1,
      } as BoxProps,
      separatorStyle: {} as BoxProps,
      itemContainer: { paddingLeft: 23 } as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        ...defaultStyles.sideMenuitemStyle,
        opacity: 1,
        fontWeight: '500',
      } as TextProps,
      leftHighlight: {
        ...defaultStyles.sideMenuleftHighLight,
        backgroundColor: 'WHITE',
      } as BoxProps,
      iconImage: {
        marginRight: 10,
      } as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  MENU_TITLE: {
    ...defaultStyles,
    iconColor: 'WHITE',
    ORIGINAL: {
      container: {
        opacity: 0.6,
        alignContent: 'flex-start',
        paddingVertical: 10,
      } as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        marginVertical: 10,
        color: 'WHITE',
        textAlign: 'left',
        fontSize: 14,
        alignContent: 'center',
        opacity: 0.6,
        fontFamily: 'jiotype-medium',
      } as TextProps,
      separatorStyle: {} as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        marginVertical: 10,
        color: 'WHITE',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: 14,
        alignContent: 'center',
      } as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  NOTIFICATION: {
    ...defaultStyles,
    iconColor: 'WHITE',
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginVertical: 8,
    } as BoxProps,
    dateStyle: {
      color: Colors.HELPER_TEXT,
      fontSize: 10,
      fontWeight: 'normal',
      paddingRight: 8,
    } as TextProps,
    ORIGINAL: {
      container: {
        alignItems: 'center',
        width: 320,
        maxWidth: 320,
        flexDirection: 'row',
        backgroundColor: 'WHITE',
        // ...Theme.viewShadowStyle,
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 3,
        shadowColor: 'SHADED_GREY',
        borderRadius: 4,
        zIndex: 4,
        borderWidth: 0,
      } as BoxProps,
      itemContainer: {
        flexGrow: 1,
        width: 0,
        marginVertical: 12,
        marginRight: 8,
      } as BoxProps,
      titleStyle: {
        textAlign: 'left',
        color: 'BLACK_GRAY_SHADE',
        fontSize: 12,
        fontWeight: 'bold',
      } as TextProps,
      itemStyle: {
        textAlign: 'left',
        color: 'PRIMARY_GREY', //logingrey
        fontSize: 12,
        fontWeight: '500',
        paddingTop: 12,
        paddingBottom: 8,
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'DISABLED_GREY',
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {
        marginTop: 24,
        alignSelf: 'flex-start',
        borderRadius: 12,
        width: 24,
        height: 24,
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 7,
        marginHorizontal: 16,
      } as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {
        alignItems: 'center',
        width: 320,
        maxWidth: 320,
        flexDirection: 'row',
        backgroundColor: 'WHITE',
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 3,
        shadowColor: 'SHADED_GREY',
        borderRadius: 4,
        zIndex: 4,
        paddingHorizontal: 8,
      } as BoxProps,
      itemContainer: { flexGrow: 1, width: 0 } as BoxProps,
      titleStyle: {
        textAlign: 'left',
        color: 'BLACK_GRAY_SHADE',
        fontSize: 12,
        fontWeight: 'bold',
        paddingHorizontal: 8,
      } as TextProps,
      itemStyle: {
        textAlign: 'left',
        color: 'PRIMARY_GREY', // LOGIN_GREY
        fontSize: 12,
        fontWeight: 'normal',
        paddingHorizontal: 8,
        paddingVertical: 8,
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'DISABLED_GREY',
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {
        marginTop: 10,
        alignSelf: 'flex-start',
        borderRadius: 12,
        width: 24,
        height: 24,
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 7,
        marginHorizontal: 8,
      } as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },

  CALENDAR: {
    ...defaultStyles,
    ORIGINAL: {
      container: {
        flex: 1,
        backgroundColor: 'WHITE',
      } as BoxProps,
      titleStyle: {} as TextProps,
      itemContainer: {} as BoxProps,
      itemStyle: {
        flex: 1,
        fontSize: 14,
        paddingHorizontal: 16,
        paddingVertical: 12,
        textAlign: 'left',
        color: 'BLACK_21',
        backgroundColor: 'WHITE',
        fontFamily: 'MEDIUM',
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'GREY_SEPARATOR',
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemContainer: {} as BoxProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },

  Modes: {
    ...defaultStyles,
    iconColor: 'DARK_GREY',
    ORIGINAL: {
      container: {
        height: 30,
        backgroundColor: 'WHITE',
        flexDirection: 'row',
        paddingHorizontal: 8,
        borderRadius: 8,
      } as BoxProps,
      itemContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
      } as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {
        fontSize: 12,
        color: 'DARK_GREY',
        fontWeight: '600',
        alignSelf: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'GRAY_SHADOW', // gray shade
        marginHorizontal: 3,
      } as BoxProps,
      leftHighlight: {
        width: 10,
        height: 10,
        borderRadius: 5,
        alignSelf: 'center',
      } as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      itemContainer: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
  INVOICE: {
    ...defaultStyles,
    ORIGINAL: {
      container: {
        flex: 1,
        backgroundColor: 'WHITE',
      } as BoxProps,
      titleStyle: {} as TextProps,
      itemContainer: {} as BoxProps,
      itemStyle: {
        flex: 1,
        fontSize: 14,
        paddingLeft: 16,
        paddingRight: 32,
        marginTop: 6,
        textAlign: 'left',
        color: 'BLACK_21',
        backgroundColor: 'WHITE',
        fontFamily: 'MEDIUM',
      } as TextProps,
      separatorStyle: {
        height: 1,
        backgroundColor: 'GREY_SEPARATOR',
        marginTop: 6,
      } as BoxProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
    SELECTED: {
      container: {} as BoxProps,
      separatorStyle: {} as BoxProps,
      titleStyle: {} as TextProps,
      itemContainer: {} as BoxProps,
      itemStyle: {} as TextProps,
      leftHighlight: {} as BoxProps,
      iconImage: {} as ViewProps,
      filterContainer: {} as BoxProps,
      filterOuterContainer: {} as BoxProps,
    },
  },
}

export default styles
